import { render, staticRenderFns } from "./CreateTaskWidget.vue?vue&type=template&id=925509ba&scoped=true&"
import script from "./CreateTaskWidget.vue?vue&type=script&lang=js&"
export * from "./CreateTaskWidget.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskWidget.vue?vue&type=style&index=0&id=925509ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925509ba",
  null
  
)

export default component.exports